<script lang="ts">
  import { onDestroy, onMount } from "svelte";
  import {
    flush,
    initializeAppsignalLogger,
    setEnabled,
  } from "./appsignalLogger";

  interface Props {
    displayId: string;
  }
  const { displayId }: Props = $props();

  function flushOnVisibilityHidden() {
    if (document.visibilityState === "hidden") flush();
  }

  onMount(() => {
    initializeAppsignalLogger({
      displayId,
      enabled: true,
    });
    window.addEventListener("pagehide", flush);
    document.addEventListener("visibilitychange", flushOnVisibilityHidden);
  });

  onDestroy(() => {
    window.removeEventListener("pagehide", flush);
    document.removeEventListener("visibilitychange", flushOnVisibilityHidden);
    setEnabled(false);
  });
</script>
